import { login, logout, getRoleMenus } from '@/api/api'
import { getAccount, setAccount, removeAccount } from '@/utils/auth'
import router, { resetRouter } from '@/router'

const state = {
  account: getAccount(),
  name: '',
  avatar: '',
  introduction: '',
  roles: []
}

const mutations = {
  SET_ACCOUNT: (state, account) => {
    state.account = account
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(response => {
        const { data } = response
        commit('SET_ACCOUNT', data.account)
        setAccount(data.account)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      console.log('here--------------')

      let params = {
        account: JSON.parse(sessionStorage.getItem('account'))
        // account: 'hlfchina'
      }

      getRoleMenus({ params: params }).then(response => {

        const data = response.data[0].roleType
        // const data =  {roleType:'admin'}

        if (!data) {
          reject('Verification failed, please Login again.')
        }
        // const { roles, name, avatar, introduction } = data[0]
        const roles = [data]
        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!')
        }

        commit('SET_ROLES', roles)
        // commit('SET_NAME', name)
        // commit('SET_AVATAR', avatar)
        // commit('SET_INTRODUCTION', introduction)
        resolve(roles)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    // return new Promise((resolve, reject) => {
    //   logout(state.account).then(() => {
    //     commit('SET_ACCOUNT', '')
    //     commit('SET_ROLES', [])
    //     removeAccount()
    //     resetRouter()
    //     resolve()
    //   }).catch(error => {
    //     reject(error)
    //   })
    // })
    commit('SET_ACCOUNT', '')
    commit('SET_ROLES', [])
    removeAccount()
    resetRouter()
    console.log("--------------logout")
  },

  // remove account
  resetAccount({ commit }) {
    return new Promise(resolve => {
      commit('SET_ACCOUNT', '')
      commit('SET_ROLES', [])
      removeAccount()
      resolve()
    })
  },

  // Dynamically modify permissions
  changeRoles({ commit, dispatch }, role) {
    return new Promise(async resolve => {
      const account = role + '-account'

      commit('SET_ACCOUNT', account)
      setAccount(account)

      const { roles } = await dispatch('getInfo')

      resetRouter()

      // generate accessible routes map based on roles
      const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })

      // dynamically add accessible routes
      router.addRoutes(accessRoutes)

      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js